import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FiArrowUp } from '../assets/icons/vander';

export default function ScrollTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const toggleVisible = () => {
      const scrolled = document.documentElement.scrollTop;
      if (scrolled > 300) {
        setVisible(true);
      } else if (scrolled <= 300) {
        setVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisible);

    // Cleanup function to remove event listener
    return () => {
      window.removeEventListener('scroll', toggleVisible);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <>
      <Link 
        to="#" 
        id="back-to-top" 
        className={`back-to-top rounded-pill fs-5 ${visible ? 'show' : ''}`} 
        onClick={scrollToTop}
      >
        <FiArrowUp className="fea icon-sm align-middle" />
      </Link>
    </>
  );
}